const onboarding = {
  languageTitle: 'Select Language',
  languageDescription: 'Choose your preferred language for the app.',
  welcomeTitle: 'Welcome to VoiceFill Medical',
  welcomeDescription: 'Streamline your medical documentation with AI.',
  feature1Title: 'Voice Recording',
  feature1Desc: 'Record your medical reports securely.',
  feature2Title: 'AI Transcription',
  feature2Desc: 'Advanced AI converts speech to structured text.',
  feature3Title: 'Secure & Private',
  feature3Desc: 'Your data is encrypted and protected.',
};

export default onboarding;
